const DEFAULT_TTL_MS = 10 * 60 * 1000; // 10 minutos

const cache = new Map();

export function getCachedBarberServices(barberId, maxAgeMs = DEFAULT_TTL_MS) {
    if (!barberId) return null;

    const entry = cache.get(barberId);
    if (!entry) return null;

    const isFresh = Date.now() - entry.fetchedAt <= maxAgeMs;
    if (!isFresh) {
        cache.delete(barberId);
        return null;
    }

    return entry.data;
}

export function setCachedBarberServices(barberId, data) {
    if (!barberId || !Array.isArray(data)) return;
    cache.set(barberId, {
        data,
        fetchedAt: Date.now()
    });
}

export function invalidateBarberServices(barberId) {
    if (barberId) {
        cache.delete(barberId);
        return;
    }
    cache.clear();
}
